import { useEffect, useState } from 'react';
import { Layout } from '@/components/layout';
import { Card, Spinner, EmptyState } from '@/components/atoms';
import { useBackButton } from '@/hooks';
import { specialists } from '@/api';
import { logger } from '@/utils/logger';
import styles from './pages.module.css';

interface Stats {
  profile_views_7d: number;
  profile_views_30d: number;
  inquiry_count_30d: number;
  response_rate: number;
  avg_response_time_minutes: number;
  conversion_rate: number;
}

export function MyStatsPage(): JSX.Element {
  useBackButton();
  const [data, setData] = useState<Stats | null>(null);
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const stats = await specialists.fetchMyStats();
        if (!cancelled) setData(stats);
      } catch (err) {
        logger.warn('Stats fetch failed', err);
        if (!cancelled) setErrored(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (errored)
    return (
      <Layout title="Статистика">
        <EmptyState icon="stats" message="Поки статистики немає — потрібен хоча б один контакт." />
      </Layout>
    );
  if (!data)
    return (
      <Layout title="Статистика">
        <Spinner center />
      </Layout>
    );

  return (
    <Layout title="Статистика">
      <div className={styles.statsGrid}>
        <Card>
          <div className={styles.statNum}>{data.profile_views_7d}</div>
          <div className={styles.statLabel}>Перегляди (7д)</div>
        </Card>
        <Card>
          <div className={styles.statNum}>{data.profile_views_30d}</div>
          <div className={styles.statLabel}>Перегляди (30д)</div>
        </Card>
        <Card>
          <div className={styles.statNum}>{data.inquiry_count_30d}</div>
          <div className={styles.statLabel}>Заявки (30д)</div>
        </Card>
        <Card>
          <div className={styles.statNum}>{Math.round(data.response_rate * 100)}%</div>
          <div className={styles.statLabel}>Response rate</div>
        </Card>
        <Card>
          <div className={styles.statNum}>{data.avg_response_time_minutes} хв</div>
          <div className={styles.statLabel}>Швидкість відповіді</div>
        </Card>
        <Card>
          <div className={styles.statNum}>{Math.round(data.conversion_rate * 100)}%</div>
          <div className={styles.statLabel}>Конверсія</div>
        </Card>
      </div>
    </Layout>
  );
}
